import { motion } from "framer-motion";
import { SIGNATURE } from "@/signaturePaths";

export default function SignatureDraw({ className = "" }) {
  return (
    <motion.svg
      data-testid="footer-signature"
      viewBox={SIGNATURE.viewBox}
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-20%" }}
      aria-label="Firma FMF"
    >
      <g transform="translate(0,531) scale(0.1,-0.1)">
        {SIGNATURE.paths.map((d, i) => (
        <motion.path
          key={i}
          d={d}
          fill="white"
          stroke="white"
          strokeWidth={2.5}
          strokeLinejoin="round"
          strokeLinecap="round"
          variants={{
            hidden: { pathLength: 0, fillOpacity: 0, strokeOpacity: 1 },
            visible: {
              pathLength: 1,
              fillOpacity: 1,
              strokeOpacity: 0.35,
              transition: {
                pathLength: {
                  delay: 0.3 + i * 0.9,
                  duration: 2.4,
                  ease: [0.4, 0, 0.2, 1],
                },
                fillOpacity: {
                  delay: 0.3 + i * 0.9 + 2.2,
                  duration: 1.8,
                  ease: "easeInOut",
                },
                strokeOpacity: {
                  delay: 0.3 + i * 0.9 + 2.2,
                  duration: 1.8,
                },
              },
            },
          }}
        />
      ))}
      </g>
    </motion.svg>
  );
}
